import React, { useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import { TableBody, TableRow, Button, Icon } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { Search } from "@mui/icons-material";
// import { pushUrl } from "../HOC/CustomFunctions/pushUrl";
import { LIST_CHARGE_TYPES } from "./Graphql";
import { useTranslation } from "react-i18next";
import CellLink from "../HOC/CustomComponents/CellLink";
import { useState } from "react";
import MUITablePagination from "../HOC/MUI/TablePagination/MUITablePagination";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import { useHistory } from "react-router";
import { pushUrl, windowUrl } from "../HOC/CustomFunctions/pushUrl";
import { urlParameters } from "../HOC/CustomFunctions/urlParameters";
import { useForm } from "react-hook-form";
import ControlMUItextField from "../HOC/MUI/ControlMUItextField";
import useWidth from "../../Hooks/useWidth";
import ListWrapper from "../CustomComponents/ListWrapper/ListWrapper";
import config from "../../config.json";
import { Globals } from "../HOC/Classes/Globals";
import MUIselect from "../HOC/MUI/MUIselect";
import { CustomAutocomplete } from "../HOC/MUI/CustomAutocomplete";
import { LIST_GL_ACCOUNTS_DROPDOWN } from "../../GlobalsQuery/ListDropdown/ListDropdown";
import { RootStyleList, classes } from "../../GlobalStyles/ListStyle";
// const DRAWER_WIDTH = 240;

const ListChargeTypes = (props) => {
  const { t } = useTranslation();

  // const listName = {
  //   B2C: t("listPriceListsCustomers"),
  //   C2C: t("listPriceListsIndividuals"),
  // };

  const [refetch, setrefetch] = useState(true);
  // const theme = useTheme();
  const urlQuery = urlParameters(window.location.search);
  // const listType = props.match?.params?.type.toUpperCase();

  const validUrlParameters = Object.keys(urlQuery).length !== 0;

  const screenWidth = useWidth();

  const [drawerState, setDrawerState] = React.useState({
    top: true,
    left: screenWidth === "xs" ? false : true,
    bottom: screenWidth === "xs" ? false : true,
    right: screenWidth === "xs" ? false : true,
  });
  const [autocompleteValues, setAutocompleteValues] = useState({
    branch: null,
  });
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm();
  const [rowsPerPage, setRowsPerPage] = useState(
    urlQuery["rowsPerPage"] ?? config.app.pageSize
  );

  const initSearch = () => {
    let searchParameters = {
      page: 0,
      refetch: true,
    };
    delete urlQuery["rowsPerPage"];
    if (validUrlParameters) {
      if (urlQuery["name"]) urlQuery["name"] = urlQuery["name"].toString();
      if (urlQuery["code"]) urlQuery["code"] = urlQuery["code"].toString();
      searchParameters = urlQuery;
    }

    return {
      ...searchParameters,
    };
  };
  const [search, setSearch] = useState(initSearch());
  useEffect(() => {
    urlQuery["name"] && setValue("name", urlQuery["name"]);
    urlQuery["code"] && setValue("code", urlQuery["code"]);
    urlQuery["active"] !== undefined && setValue("active", urlQuery["active"]);
    urlQuery["payable"] !== undefined &&
      setValue("payable", urlQuery["payable"]);
    urlQuery["receivable"] !== undefined &&
      setValue("receivable", urlQuery["receivable"]);
    setAutocompleteValues((prev) => ({
      ...(urlQuery["receivableGLAccountId"] && {
        receivableGLAccount: urlQuery["receivableGLAccountId"],
      }),
      ...(urlQuery["payableGLAccountId"] && {
        payableGLAccount: urlQuery["payableGLAccountId"],
      }),
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const history = useHistory();

  const pushUrlSearch = (param) => {
    const queryParams = [];
    for (const i in param) {
      encodeURIComponent(param[i]) &&
        queryParams.push(
          encodeURIComponent(i) + "=" + encodeURIComponent(param[i])
        );
    }
    const queryString = queryParams.join("&");

    const url = history.createHref({
      pathname: `/admin/charge-types`,
      search: "?" + queryString,
    });
    windowUrl(url);
    //this will not effect on history.location.search
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      (event.type === "keydown" || event.type === "submit") &&
      (event.type === "submit" || event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerState({ ...drawerState, [anchor]: open });
  };
  const filterAnchor = screenWidth === "xs" ? "bottom" : "left";
  const parseData = (data) => {
    return data;
  };

  const onSubmit = (data) => {
    filterAnchor === "bottom" &&
      setDrawerState({ ...drawerState, [filterAnchor]: false });
    refetch ? setrefetch(false) : setrefetch(true);
    let handledData = {
      name: data.name,
      code: data.code,
      page: 0,
      receivableGLAccountId: data.receivableGLAccountId,
      payableGLAccountId: data.payableGLAccountId,
      active: data.active,
      receivable: data.receivable,
      payable: data.payable,
    };
    data["active"] === "" && delete handledData["active"];
    data["receivable"] === "" && delete handledData["receivable"];
    data["payable"] === "" && delete handledData["payable"];
    for (const key in handledData) {
      if (
        handledData[key] === undefined ||
        handledData[key] === "" ||
        handledData[key] === null
      ) {
        delete handledData[key];
      }
    }
    setSearch((prev) => ({
      ...handledData,
      refetch: !prev.refetch,
    }));
    for (const key in handledData) {
      if (handledData[key] === null) {
        delete handledData[key];
      }
    }
    pushUrlSearch({
      ...handledData,
      rowsPerPage: rowsPerPage,
    });
  };
  const [noData, setNoData] = useState(true);
  const { data, loading } = useQuery(
    gql`
      ${LIST_CHARGE_TYPES.query}
    `,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      partialRefetch: refetch,
      variables: {
        first: rowsPerPage,
        page: search?.page + 1,
        input: {
          ...(search.name && { name: search.name }),
          ...(search.code && { code: search.code }),
          ...(search.receivableGLAccountId && {
            receivableGLAccountId: search.receivableGLAccountId,
          }),
          ...(search.payableGLAccountId && {
            payableGLAccountId: search.payableGLAccountId,
          }),
          active: search.active,
          receivable: search.receivable,
          payable: search.payable,
        },
      },
      onCompleted: () => {
        setNoData(false);
      },
    }
  );
  const listChargeTypes = data?.listChargeTypes?.data;

  const handleChangePage = (event, newPage) => {
    pushUrlSearch({
      ...urlQuery,
      page: newPage,
      rowsPerPage: rowsPerPage,
    });

    setSearch((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    pushUrlSearch({
      ...urlQuery,
      page: 0,
      rowsPerPage: +event.target.value,
    });

    setRowsPerPage(+event.target.value);
    setSearch((prev) => ({ ...prev, page: 0 }));
  };
  const user = Globals.user;
  // const pagePermission = GetPermissionSlug("shipping", "price_list","list")

  const icons = [
    {
      id: "filterList",
      action: toggleDrawer(filterAnchor, !drawerState[filterAnchor]),
    },
    {
      id: "add",
      action: () => pushUrl(props, `/admin/charge-types/create`),
      permission: user?.hasPermission("freight.charge_type.create"),
    },
  ];

  return (
    <RootStyleList>
      <ListWrapper
        drawerState={drawerState[filterAnchor]}
        icons={icons}
        path={props.match.path}
        empty={listChargeTypes?.length === 0}
        loading={loading}
        filters={
          <Grid
            container
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            className={classes.filterForm}
          >
            <Grid
              container
              item
              sm={12}
              justifyContent="flex-start"
              spacing={1}
              className={classes.filterField}
            >
              <Grid item sm={12} alignItems="flex-start">
                <ControlMUItextField
                  control={control}
                  errors={errors}
                  name={"code"}
                  label={t("code")}
                />
              </Grid>
              <Grid item sm={12} alignItems="flex-start">
                <ControlMUItextField
                  control={control}
                  errors={errors}
                  name={"name"}
                  label={t("name")}
                />
              </Grid>
              <Grid item sm={12} alignItems="flex-start">
                <Grid item sm={12} alignItems="flex-start">
                  <CustomAutocomplete
                    control={control}
                    errors={errors}
                    skip={noData}
                    name={"receivableGLAccountId"}
                    label={t("receivableGLAccount")}
                    parseData={(data) => parseData(data)}
                    query={LIST_GL_ACCOUNTS_DROPDOWN.query}
                    variables={{
                      input: {
                        typeCode: "SUB",
                      },
                    }}
                    defaultValue={autocompleteValues.receivableGLAccount}
                  />
                </Grid>

                <Grid item sm={12} alignItems="flex-start">
                  <MUIselect
                    name={"receivable"}
                    label={t("receivable")}
                    control={control}
                    errors={errors}
                    data={[
                      { key: t("notActive"), value: false },
                      { key: t("active"), value: true },
                    ]}
                  />
                </Grid>
                <Grid item sm={12} alignItems="flex-start">
                  <CustomAutocomplete
                    control={control}
                    skip={noData}
                    errors={errors}
                    name={"payableGLAccountId"}
                    label={t("payableGLAccount")}
                    parseData={(data) => parseData(data)}
                    query={LIST_GL_ACCOUNTS_DROPDOWN.query}
                    variables={{
                      input: {
                        typeCode: "SUB",
                      },
                    }}
                    defaultValue={autocompleteValues.payableGLAccount}
                  />
                </Grid>
                <Grid item sm={12} alignItems="flex-start">
                  <MUIselect
                    name={"payable"}
                    label={t("payable")}
                    control={control}
                    errors={errors}
                    data={[
                      { key: t("notActive"), value: false },
                      { key: t("active"), value: true },
                    ]}
                  />
                </Grid>
              </Grid>
              <Grid item sm={12} alignItems="flex-start">
                <MUIselect
                  name={"active"}
                  label={t("active")}
                  control={control}
                  errors={errors}
                  data={[
                    { key: t("notActive"), value: false },
                    { key: t("active"), value: true },
                  ]}
                />
              </Grid>
            </Grid>

            <Grid
              container
              item
              sm={12}
              className={classes.button}
              alignItems="flex-end"
              justifyContent="flex-end"
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="medium"
                color="primary"
                startIcon={<Search />}
              >
                {t("search")}
              </Button>
            </Grid>
          </Grid>
        }
        tableHeaders={[
          {
            name: "manifestName",
          },
          {
            name: "code",
          },

          {
            name: "receivable",
          },
          {
            name: "receivableGLAccount",
          },
          {
            name: "payable",
          },
          {
            name: "payableGLAccount",
          },
          {
            name: "active",
          },
        ]}
        tableBody={
          <TableBody>
            {listChargeTypes &&
              listChargeTypes?.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <CellLink pathname={`/admin/charge-types/${row.id}`}>
                      {row?.name}
                    </CellLink>
                    <FixedTableCell>{row.code}</FixedTableCell>
                    <FixedTableCell>
                      {row?.receivable ? (
                        <Icon className={classes.iconColor}>
                          check_circle_outline
                        </Icon>
                      ) : (
                        <Icon color="error">highlight_off</Icon>
                      )}
                    </FixedTableCell>
                    <FixedTableCell>
                      {row.receivableGLAccount?.name}
                    </FixedTableCell>
                    <FixedTableCell>
                      {row?.payable ? (
                        <Icon className={classes.iconColor}>
                          check_circle_outline
                        </Icon>
                      ) : (
                        <Icon color="error">highlight_off</Icon>
                      )}
                    </FixedTableCell>
                    <FixedTableCell>
                      {row.payableGLAccount?.name}
                    </FixedTableCell>
                    <FixedTableCell>
                      {row?.active ? (
                        <Icon className={classes.iconColor}>
                          check_circle_outline
                        </Icon>
                      ) : (
                        <Icon color="error">highlight_off</Icon>
                      )}
                    </FixedTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        }
        pagination={
          <MUITablePagination
            count={data?.listChargeTypes?.paginatorInfo?.total}
            rowsPerPage={rowsPerPage}
            page={!data?.listChargeTypes ? 0 : search.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      />
    </RootStyleList>
  );
};

export default ListChargeTypes;
